import { TargetingSearch } from './targeting-search.model';
import { DistributionRecipientApiModel } from '../../../api/distributions/model/distribution-api.model';
import { DistributionRecipientStatus } from '../enums/distribution-recipient-status.enum';
import { SearchModeEnum } from '@Common/TargetingShared/enum/search-mode.enum';

export class DistributionRecipientModel {
    // The distrib object from the backend will contain these fields
    targetingListId?: number;
    targetingSearchId?: number;
    portfolioId?: number;
    mailingListId?: number;
    filterSearch?: TargetingSearch;
    status?: DistributionRecipientStatus;
    searchMode?: SearchModeEnum;
    isLocked: boolean = false;

    // These have to be loaded afterward by the front end
    count: number = 0;
    contactCount: number;
    outletCount: number;
    label?: string;

    constructor(apiModel?: DistributionRecipientApiModel) {
        if (apiModel) {
            this.targetingListId = apiModel.targetingListId;
            this.portfolioId = apiModel.portfolioId;
            this.targetingSearchId = apiModel.targetingSearchId;
            this.mailingListId = apiModel.mailingListId;

            this.isLocked = !!(this.targetingListId && this.targetingSearchId);

            if (apiModel.filterSearch) {
                this.filterSearch = new TargetingSearch(apiModel.filterSearch);
            }
        }
    }

    equals(other: DistributionRecipientModel) {
        let searchesEqual = false;
        if (!this.filterSearch && !other.filterSearch) {
            searchesEqual = true;
        } else if (this.filterSearch && this.filterSearch.equals(other.filterSearch)) {
            searchesEqual = true;
        }

        return this.targetingListId === other.targetingListId &&
            this.targetingSearchId === other.targetingSearchId &&
            this.portfolioId === other.portfolioId &&
            searchesEqual;
    }

    toApiModel() {
        return {
            filterSearch: !!this.filterSearch ? this.filterSearch.toApiModel() : null,
            targetingListId: this.targetingListId,
            targetingSearchId: this.targetingSearchId,
            mailingListId: this.mailingListId,
            portfolioId: this.portfolioId
        };
    }

    clone(): DistributionRecipientModel {
        const clone = new DistributionRecipientModel();
        clone.targetingListId = this.targetingListId;
        clone.targetingSearchId = this.targetingSearchId;
        clone.portfolioId = this.portfolioId;
        clone.mailingListId = this.mailingListId;
        clone.filterSearch = this.filterSearch?.clone(false);
        clone.status = this.status;
        clone.count = this.count;
        clone.contactCount = this.contactCount;
        clone.outletCount = this.outletCount;
        clone.label = this.label;
        clone.isLocked = this.isLocked;

        return clone;
    }
}
